<template>
  <component :is="layout"></component>
</template>
<script>
import Vue from "vue";

// Layouts
import LoginLayout from "./components/testing/RomaLayoutLogin"; //test layout
import MainLayout from "./components/commons/RomaLayoutMain";
import GeneralLayout from "./components/layouts/GeneralLayout";

import { mapActions, mapGetters } from "vuex";
import Vuetify from "vuetify";
Vue.use(Vuetify);
export default {
  components: { LoginLayout, MainLayout, GeneralLayout },
  created() {
    this.actionGetUser();
  },
  computed: {
    ...mapGetters({
      layout: "getLayout",
      getUserData: "getUserData"
    })
  },
  methods: {
    ...mapActions({
      actionGetUser: "actionGetUser",
      actionSetLayout: "setLayout"
    })
  }
};
</script>
